import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Breadcrumb from '../components/ui/Breadcrumb';
import StatisticsView from '../components/statistics/StatisticsView';
import LoadingBall from '../components/loading/LoadingBall';
import { fetchComplexById } from '../api/complexes';
import { getField } from '../api/fields';
import { Complex, Field } from '../types';
import { COMMON_TRANSLATE_KEYS } from '../constants/translate-keys';

const FieldStatistics = () => {
  const { id, fieldId } = useParams<{ id: string; fieldId: string }>();
  const { t } = useTranslation();

  const [complex, setComplex] = useState<Complex | null>(null);
  const [field, setField] = useState<Field | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const [complexResult, fieldResult] = await Promise.all([
        fetchComplexById(Number(id)),
        getField(Number(id), Number(fieldId)),
      ]);

      if (complexResult.data) {
        setComplex(complexResult.data);
      }

      if (fieldResult.data) {
        setField(fieldResult.data);
      }
    };

    fetchData();
  }, [id, fieldId]);

  if (!complex || !field) {
    return <LoadingBall className="w-full h-screen" />;
  }

  return (
    <div className="mx-[30px] mb-10">
      <Breadcrumb
        className="sm:mb-8 mb-10"
        links={[
          {
            name: t(COMMON_TRANSLATE_KEYS.COMPLEXES),
            to: '/my-fields',
          },
          {
            name: `${complex.name} (${t(COMMON_TRANSLATE_KEYS.COMPLEX)})`,
            to: `/arena/${complex.id}/info`,
          },
          {
            name: `${field.name} (${t(COMMON_TRANSLATE_KEYS.FIELD)})`,
            to: `/arena/${complex.id}/field-reservation/${field.id}`,
          },
        ]}
      >
        {t(COMMON_TRANSLATE_KEYS.STATISTICS)}
      </Breadcrumb>
      <StatisticsView
        complexId={complex.id}
        fieldId={field.id}
        fields={[{ id: field.id, name: field.name }]}
        openingHours={complex.openingHours}
        closingHours={complex.closingHours}
      />
    </div>
  );
};

export default FieldStatistics;
